"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditOfficeholderSchema = exports.OfficeholderSchema = void 0;
const yup = __importStar(require("yup"));
const moment_1 = __importDefault(require("moment"));
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const User_1 = require("./User");
const constants_1 = require("../constants");
const MyStakeAddress_1 = require("./MyStakeAddress");
const OptionGrant_1 = require("./OptionGrant");
const OfficeholderFormSchema = {
    directorId: yup
        .string()
        .trim()
        .notRequired()
        .matches(/^[0-9\s]*$/, "director id should contain only digits")
        .test("directorID", "Director ID should be 15 digits.", (directorId) => {
        const digits = (directorId ?? "").replace(/\s/g, "");
        if (digits.length === 0)
            return true;
        return digits.length === 15;
    }),
    name: yup.object({
        salutation: User_1.UserSchema.salutation,
        firstName: User_1.UserSchema.firstName,
        secondName: User_1.UserSchema.secondName,
        thirdName: User_1.UserSchema.thirdName,
        familyName: User_1.UserSchema.familyName,
    }),
    email: yup.string().email().max(255),
    formerNames: yup.array().of(yup.object({
        salutation: User_1.UserSchema.salutation,
        firstName: User_1.UserSchema.firstName,
        secondName: User_1.UserSchema.secondName,
        thirdName: User_1.UserSchema.thirdName,
        familyName: User_1.UserSchema.familyName,
    })),
    appointmentDate: yup
        .string()
        .required(constants_1.DATE_REQUIRED)
        .typeError(constants_1.DATE_VALID)
        .test("appointmentDate", constants_1.DATE_VALID, (appointmentDate) => appointmentDate && (0, moment_1.default)(appointmentDate).isValid() && (0, mystake_common_sdk_1.getDateYear)(appointmentDate) > 1920)
        .test("Date-in-future", constants_1.DATE_NOT_FUTURE, (appointmentDate) => new Date(appointmentDate).valueOf() <= new Date().valueOf()),
    authorisingOfficer: OptionGrant_1.AuthorisingOfficerSchema,
};
exports.OfficeholderSchema = yup.object(MyStakeAddress_1.MyStakeAddressSchema).shape({
    ...OfficeholderFormSchema,
    phone: yup.object({
        iso2Code: yup.string().matches(/^[A-Z]{2}$/, "Invalid iso2 code"),
        iso2: yup.string().matches(/^[A-Z]{2}$/, "Invalid iso2 code"),
        dialCode: yup.string().matches(/^\+[1-9]\d{0,3}$/, "Invalid dial code"),
        phoneNumber: yup
            .string()
            .trim()
            .matches(/^\d{1,14}$/, "Phone Number can only contain digits, at most 14 digits are allowed"),
    }),
    dob: User_1.UserSchema.dob,
    birthPlace: yup
        .string()
        .trim()
        .max(30)
        .when("birthCountry", ([birthCountry], schema) => birthCountry.toLowerCase() === "australia" // ASIC only requires a state when birth country is Australia
        ? schema.required(User_1.REQUIRED_FIELD_MESSAGE)
        : schema.notRequired()),
    birthCountry: yup.string().trim().max(30).required(User_1.REQUIRED_FIELD_MESSAGE),
    birthState: yup
        .string()
        .trim()
        .max(30)
        .when("birthCountry", ([birthCountry], schema) => birthCountry.toLowerCase() === "australia" // ASIC only requires a state when birth country is Australia
        ? schema.required(User_1.REQUIRED_FIELD_MESSAGE)
        : schema.notRequired()),
});
exports.EditOfficeholderSchema = yup.object(MyStakeAddress_1.MyStakeAddressSchema).shape({
    ...OfficeholderFormSchema,
    phone: yup.object({
        phoneNumber: yup
            .string()
            .trim()
            .notRequired()
            .matches(/^\d{1,14}$/, {
            excludeEmptyString: true,
            message: "Phone Number can only contain digits, at most 14 digits are allowed",
        }),
    }),
});
//# sourceMappingURL=Officeholder.js.map